// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip_tooltip__loy+5","right":"tooltip_right__OIh2o","top":"tooltip_top__woPMk"};